import { render } from "./component-receiver.vue?vue&type=template&id=27f3301c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-receiver.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27f3301c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27f3301c', __exports__)) {
    api.reload('27f3301c', __exports__)
  }
  
  module.hot.accept("./component-receiver.vue?vue&type=template&id=27f3301c", () => {
    api.rerender('27f3301c', render)
  })

}


export default __exports__